@import '../../../constants/spacing.module.less';

.title-wrapper {
  justify-content: space-between;
}

.card-content {
  width: 100%;
}

.split-title {
  justify-content: space-between;
}
.header-button {
  flex-wrap: nowrap;
  align-items: center;
}

.button-icon {
  height: 12px;
  width: 12px;
}

.cell-row {
  flex-flow: row nowrap;
}

.verification-summary {
  color: var(--gray-637381);
}

.space-gap {
  gap: @space-8;
}

.modal-body {
  padding: @space-16;
}

.step-card {
  padding: @space-16;

  &.inactive {
    background-color: var(--gray-F1F2F3);
  }
}
.card-body {
  width: 100%;
}

.step-title-with-check {
  .space-gap;
  align-items: center;
}

.grid-button {
  margin-left: 10px;
}

.column {
  flex: auto;
}

.data-table {
  margin-top: 0;
}

.order-errors {
  display: flex;
  justify-content: flex-end;
}

.ready-to-pick-modal {
  height: 620px;
  overflow: auto;
}

.loading {
  width: 120px;
  height: 120px;
}

.card-icon {
  margin-top: @space-4;
}
